<template>
  <b-form>
    <div class="d-flex align-items-center">
      <span class="label-type-2 mr-2">Notes to Customer</span>
      <switches
        v-model="selectedValue.enable"
        @input="$root.$emit('changesDetected')"
        theme="custom"
        color="primary"
        type-bold="true"
        style="top: 12px"
        :emit-on-mount="false"
      />
      <span class="ml-2">
        <small class="text-muted">{{
          `${selectedValue.enable ? "Enabled" : "Disabled"}`
        }}</small>
      </span>
    </div>
    <div class="info mt-2">
      <img
        src="@/assets/images/icons/blue-filled-rounded-i.png"
        alt="Information"
      />
      <span class="ml-2">Turn this on allow to display in all platform</span>
    </div>
    <b-row class="mt-3">
      <b-col md="8">
        <b-form-group
          label="Title"
          label-for="title"
          :invalid-feedback="errorMessage('notes_to_customers.title')"
        >
          <b-input
            id="title"
            v-model="selectedValue.title"
            @input="$root.$emit('changesDetected')"
            :maxlength="titleMaxLength"
            :disabled="!selectedValue.enable"
            :state="isInvalid('notes_to_customers.title')"
            @keypress.native="onKeypressFilter"
          />
          <div class="char-count">
            {{ selectedValue.title ? selectedValue.title.length : 0 }} /
            {{ titleMaxLength }}
          </div>
        </b-form-group>
        <b-form-group
          label="Instruction"
          label-for="message"
          :invalid-feedback="errorMessage('notes_to_customers.message')"
        >
          <b-textarea
            id="message"
            v-model="selectedValue.message"
            @input="$root.$emit('changesDetected')"
            :maxlength="messageMaxLength"
            :disabled="!selectedValue.enable"
            rows="5"
            :state="isInvalid('notes_to_customers.message')"
            @keypress="onKeypressFilter"
          />
          <div class="char-count">
            {{ selectedValue.message ? selectedValue.message.length : 0 }}
            /
            {{ messageMaxLength }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Switches from "vue-switches";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      titleMaxLength: 20,
      messageMaxLength: 100,
    };
  },
  computed: {
    ...mapState("orderFulfillment", ["errors"]),
  },
  props: ["selectedValue"],
  watch: {
    "selectedValue.enable"() {
      this.debouncedForceUpdate();
    },
    "selectedValue.title"() {
      this.debouncedForceUpdate();
    },
    "selectedValue.message"() {
      this.debouncedForceUpdate();
    },
  },
  components: {
    Switches,
  },
  methods: {
    ...mapMutations({
      setErrors: "orderFulfillment/set_errors",
    }),
    isInvalid(key) {
      return this.errors && this.errors[key] ? false : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key] ? this.errors[key] : null;
    },
    onKeypressFilter(e) {
      if (/[^a-z0-9;!:?.()\[\]\-_\s]/i.test(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
  },
  created() {
    this.debouncedForceUpdate = _.debounce(() => {
      this.$forceUpdate();
      this.setErrors(null);
      this.$emit("setNotesToCustomer", this.selectedValue);
    }, 300);
  },
};
</script>

<style lang="scss" scoped>
.char-count {
  margin-top: 5px;
  text-align: right;
  font-size: 11px;
  color: #6c757d;
}
.info {
  padding: 3px 10px;
  width: 300px;
  height: 31px;
  background: #f8f9f9;
  border-radius: 5px;
  span {
    font-size: 12px;
  }
}
</style>